export const MIN_METRICS_TO_SELECT = 3;
export const MAX_METRICS_TO_SELECT = 3;
export const METRICS_MODAL_INSTRUCTIONS = 'Please select 3 metrics.';
